import React from "react";
import { Github, Linkedin, Mail, Heart } from "lucide-react";
import { personalInfo, navLinks } from "../data/mock";

const Footer = () => {
  return (
    <footer className="relative border-t border-white/5 bg-[#040406]">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-12 md:py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg glass-strong flex items-center justify-center">
                <span className="font-display text-sm font-bold text-cyan-300">VB</span>
              </div>
              <span className="font-display text-lg font-semibold text-white">
                {personalInfo.name}
              </span>
            </div>
            <p className="text-sm text-zinc-400 max-w-md leading-relaxed">
              Backend engineer building scalable systems with Java, Spring Boot and Kafka. Always shipping, always learning.
            </p>
            <div className="mt-5 flex items-center gap-2">
              <a
                href={personalInfo.github}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-xl glass flex items-center justify-center text-zinc-400 hover:text-cyan-300 hover:border-cyan-400/30 transition-colors"
                aria-label="GitHub"
              >
                <Github className="w-4 h-4" />
              </a>
              <a
                href={personalInfo.linkedin}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-xl glass flex items-center justify-center text-zinc-400 hover:text-cyan-300 hover:border-cyan-400/30 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href={`mailto:${personalInfo.email}`}
                className="w-10 h-10 rounded-xl glass flex items-center justify-center text-zinc-400 hover:text-cyan-300 hover:border-cyan-400/30 transition-colors"
                aria-label="Email"
              >
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-zinc-500 mb-4">
              Navigate
            </p>
            <ul className="space-y-2">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-zinc-400 hover:text-cyan-300 transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-zinc-500 mb-4">
              Get in touch
            </p>
            <a
              href={`mailto:${personalInfo.email}`}
              className="block text-sm text-white hover:text-cyan-300 transition-colors"
            >
              {personalInfo.email}
            </a>
            <a
              href={`tel:${personalInfo.phone}`}
              className="block text-sm text-zinc-400 hover:text-cyan-300 transition-colors mt-1"
            >
              {personalInfo.phone}
            </a>
            <p className="text-xs text-zinc-500 mt-3">{personalInfo.location}</p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono text-[11px] text-zinc-600">
            © {new Date().getFullYear()} {personalInfo.name}. All rights reserved.
          </p>
          <p className="font-mono text-[11px] text-zinc-600 inline-flex items-center gap-1.5">
            Built with <Heart className="w-3 h-3 text-cyan-400 fill-cyan-400" /> using React, Three.js & Framer Motion.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
